import o from"./_root.js";var r=o.Symbol;export{r as default};
//# sourceMappingURL=_Symbol.js.map
